import React from 'react';

import SettingsPage from './SettingsPage';
import Protected from '../../components/common/protected';

/**
 * A simple wrapper that guarantees there is a user object before
 * rendering SettingsPage
 * */
export default class SettingsPageContainer extends React.Component {

    componentDidMount() {
        if (!this.props.ravens) this.props.getUserData();
    }

    render() {
        if(!this.props.ravens) return null;

        return (
            <Protected resource="settings" action="read" showNotFound>
                <SettingsPage {...this.props} />
            </Protected>
        );
    }
}
